<script>
    import {onMount} from 'svelte'
    import {link} from 'svelte-spa-router'
    let open = null
    const handleClick = ()=>{
        open = !open
        document.body.classList.toggle("--noscroll")
    }
    let height = window.innerHeight
    window.addEventListener("resize",()=>{
        height = window.innerHeight
    })
</script>

<header id="global-header" class:open>
    <div class="global-header-inner">
        <div class="global-header-content">
            <a href="/" use:link><img class="header-logo" src="img/header-logo.svg" alt="" ></a>
            <div class="header-menu-list">
                <a href="/company" use:link> 会社情報</a>
                <a href="/service" use:link> 事業内容</a>
                <a href="/recruit" use:link> 採用情報</a>
                <a href="/product" use:link>商品について</a>
                <a href="/news" use:link> ニュースリリース</a>
                <a href="/contact"  use:link> お問い合わせ</a>
            </div>
            <div class="header-menu-mobile-bt">
                <span class="btn-like"  on:click={handleClick} ><img src="img/Guide_open_regular.svg" alt=""></span>
            </div>
        </div>
    </div>
</header>
<div class="mb-menu" class:open style={`height:${height}px`}>
    <div class="mb-menu-inner">
        <div class="row">
            <span><img class="header-logo" src="img/header-logo_wh.svg" alt="" ></span>
            <span class="btn-like"  on:click={handleClick} ><img src="img/Guide_close_regular.svg" alt=""></span>
        </div>
        <div class="mb-links">
            <a on:click={handleClick} href="/company" use:link> 会社情報</a>
            <a on:click={handleClick} class="sub" href="/company/about" use:link>-企業方針_Policy</a>
            <a on:click={handleClick} class="sub" href="/company/info" use:link>-会社概要_Info</a>
            <a on:click={handleClick} class="sub" href="/company/info/#history" use:link>-沿革_History</a>
            <a on:click={handleClick} class="sub" href="/company/info/#map" use:link>-拠点情報_Access</a>
            <a on:click={handleClick} href="/service" use:link> 事業内容</a>
            <a on:click={handleClick} href="/recruit" use:link> 採用情報</a>
            <a on:click={handleClick} href="/product" use:link>商品について</a>
            <a on:click={handleClick} href="/news" use:link> ニュースリリース</a>
            <a on:click={handleClick} href="/privacy" use:link>個人情報保護方針</a>
        </div>
        <div class="addr">
            <p>〒136-0071
                東京都江東区亀戸5丁目33番5号
                TEL：03-3684-1875
                FAX：03-3684-1814</p>
        </div>
        <div class="btn">
            <a href="/contact" on:click={handleClick} use:link><span>お問い合わせ</span><span>→</span></a>
        </div>
    </div>
</div>
<style>
    #global-header{
        position: fixed;
        width: 100%;
        margin-top: 24px;
        z-index:200000;
    }
    a{
        opacity:1;
        transition:all 0.5s;
    }
    a:hover{
        opacity :0.5;
        transition: all 0.5s;
    }
    .btn-like{
        cursor: pointer;
        opacity:1;
        transition:all 0.5s;
    }
    .btn-like:hover{
        opacity :0.5;
        transition: all 0.5s;
    }
    .global-header-inner{
        position: relative;
        display: flex;
        width: 1124px;
        height: 75px;
        border-radius: 10px;
        background: #fff;
        margin:0 auto;

    }
    .global-header-content{
        width:1004px;
        height:35px;
        display: flex;
        margin:auto;
        justify-content: space-between;
    }
    .header-logo{
        width: 145px;
        height:35px;
    }
    .header-menu-list{
        display: flex;
        width: auto;
        height:21px;
        margin: auto 0;
        gap: 20px;
        position: relative;
        justify-content: space-between;
    }
    .header-menu-list a{
        text-decoration: none;
        font-family: 'Noto Sans JP',sans-serif;
        font-weight: normal;
        font-size: 15px;
        letter-spacing: 0.05em;
        text-align: left;
        color: #000;
    }
    .header-menu-mobile-bt,.mb-menu{
        display:none;
    }
    @media screen and (max-width:640px){
        .header-menu-mobile-bt{
            display:flex;
            margin-top: 2px;
        }
        #global-header.open{
            display: none;
        }
        .mb-menu.open{
            display: flex;
            margin: auto;
            width:100%;
            height:920px;
            background: #d5bc99;
            overflow-y:scroll ;
        }
        .global-header-inner{
            width:90%;
            height: 47px;
        }
        .global-header-content{
            width:95%;
            height:26px;
            justify-content: space-between;
            align-items: center;
        }
        .header-logo{
            width: 108px;
            height:26px;
            margin-top: 4px;
        }
        .header-menu-list{
            display: none;
        }
        .mb-menu-inner{
            width:90%;
            height:920px;
            display: flex;
            margin:0 auto;
            flex-direction: column;
        }
        .mb-menu-inner .header-logo{
            fill: white;
        }
        .row{
            display: flex;
            width: 100%;
            height:24px;
            margin-top: 32px;
            justify-content: space-between;
            align-items: center;
        }
        .mb-links{
            display: flex;
            flex-direction: column;
            margin-top: 66px;   
        }
        .mb-links a{
            font-family: "Noto Sans JP",sans-serif;
            font-weight: normal;
            font-size: 16px;
            letter-spacing: 0.2em;
            line-height: 36px;
            text-align: left;
            color: #fff;
            text-decoration: none;
        }
        .mb-links a:after{
            content:"";
            display: flex;
            width: 20px;
            height: 2px;
            border-radius: 1px;
            background: #ff9b11;
        }
        .mb-links a{
            margin-bottom: 40px;
        }
        .mb-links .sub{
            margin-top: 20px;
            margin-bottom: 0;
            font-size: 14px;
            line-height: 20px;
        }
        .mb-links .sub:nth-child(5){
            margin-bottom: 40px;
        }
        .mb-links a:nth-child(1){
            margin-bottom: 0;
        }
        .mb-links .sub:after{
            display: none;
        }
        .addr{
            position: relative;
        }
        .addr p{
            white-space: pre-line;
            font-family: "Noto Sans JP",sans-serif;
            font-weight: normal;
            font-size: 14px;
            line-height: 36px;
            text-align: left;
            color: #fff;
        }
        .btn{
        padding-bottom: 45px;
        }
        .btn a{
            width: 265px;
            height: 40px;
            background: #FF9B11;
            display: flex;
            color:white;
            justify-content: space-around;
            align-items: center;
            font-family: "Noto Sans JP";
            font-weight: normal;
            font-size: 14px;
            line-height: 40px;
            text-align: left;
            color: #fff;
            text-decoration: none;
        }
    }
</style>